import { FC } from "react";
import { IconProps } from "./types";

export const MailCircle: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.547 7.364h10.904a.547.547 0 0 1 .549.547v8.178a.547.547 0 0 1-.547.547H6.547A.547.547 0 0 1 6 16.089V7.91a.547.547 0 0 1 .547-.547zm.544 8.18h9.813l.003-5.617-4.771 2.89a.245.245 0 0 1-.274 0l-4.771-2.808v5.535zm4.905-3.94a.245.245 0 0 0 .136-.041l4.774-3.108H7.087l4.772 3.108c.04.027.088.041.137.041z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-1.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5z"
      fill={fill}
    />
  </svg>
);
